<template>
    <div class="footer">
        <Parallax class="before" :effect="'translateY'" :power="-0.2"/>

        <div class="footer-sizer">
        <div class="gabarit">
            <div class="intro-content">
                <router-link :to="$trl({
                    name: 'Home',
                    params: {
                        locale: $route.params.locale
                    }
                })" aria-label="Soletanche Bachy">
                    <Logo/>
                    <span class="sea-link-name">Soletanche Bachy</span>

                </router-link>
                <p
                    v-for="text in $t('footer.text').split('\n')"
                    class="text"
                    v-html="text"
                    :key="text"
                >
                </p>
            </div>
            <div class="main-content">
                <div class="division">
                    <h3>{{$t('common.aboutus')}}</h3>
                    <router-link :to="$trl({
                        name: 'About',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.about')}}
                    </router-link>
                    <router-link :to="$trl({
                        name: 'Direction',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.direction')}}
                    </router-link>
                    <router-link :to="$trl({
                        name: 'News',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.news')}}
                    </router-link>
                </div>
                <div class="division">
                    <h3>{{$t('common.ourwork')}}</h3>
                    <router-link :to="$trl({
                        name: 'Projects',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.projects')}}
                    </router-link>
                    <router-link :to="$trl({
                        name: 'Markets',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.markets')}}
                    </router-link>
                    <router-link :to="$trl({
                        name: 'Techniques',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.techniques')}}
                    </router-link>
                    <router-link :to="$trl({
                        name: 'Innovation',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.innovation')}}
                    </router-link>
                </div>
                <div class="division">
                    <h3>{{$t('common.contactus')}}</h3>
                    <router-link :to="$trl({
                        name: 'Joinus',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.joinus')}}
                    </router-link>
                    <router-link :to="$trl({
                        name: 'Contact',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.contact')}}
                    </router-link>
                    <router-link :to="$trl({
                        name: 'Contact',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.oursub')}}
                    </router-link>
                </div>
                <div class="division">
                    <h3>{{$t('nav.findus')}}</h3>
                    <div>
                        <a href="https://www.linkedin.com/company/soletanche-bachy/" class="share-link share-link-icon" target="_blank" rel="noopener" aria-label="Linkedin">
                            <IconLinkedin class="logo linkedin"/>
                            <span class="sea-link-name">Linkedin</span>
                        </a>
                        <a href="https://www.youtube.com/channel/UCnWhof4dRavOkevAbECraag" class="share-link share-link-icon" target="_blank" rel="noopener" aria-label="Youtube">
                            <IconYoutube class="logo youtube"/>
                            <span class="sea-link-name">Youtube</span>
                        </a>
                    </div>
                </div>
                <div class="division">
                    <router-link :to="$trl({
                        name: 'Legal',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.legalnotices')}}
                    </router-link>
                    <router-link :to="$trl({
                        name: 'Privacy',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.privacypolicy')}}
                    </router-link>
                    <router-link :to="$trl({
                        name: 'Termsofuse',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.termsofuse')}}
                    </router-link>
                    <router-link :to="$trl({
                        name: 'Credits',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.credits')}}
                    </router-link>
                    <router-link :to="$trl({
                        name: 'TechnicalGuide',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.technicalguide')}}
                    </router-link>
                    <router-link :to="$trl({
                        name: 'Sitemap',
                        params: {
                            locale: $route.params.locale
                        }
                    })">
                        {{$t('nav.sitemap')}}
                    </router-link>
                </div>
            </div>
            <div class="end-content">
                <div class="division">
                    <SwitchLang :current-lang="$route.params.locale && $route.params.locale"/>
                </div>
                <div class="division last-division">
                    <span class="prefix">{{$t('common.asubsidiaryof')}}</span>
                    <a :href="$t('nav.freyssineturl')" target="_blank" class="link" rel="noopener" aria-label="Soletanche Freyssinet">
                        <img src="./../assets/SF.svg" class="default-icon" alt="Soletanche Freyssinet's logo">
                        <span class="sea-link-name">Soletanche Freyssinet</span>
                    </a>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import Logo from '@/components/Logo'
import SwitchLang from '@/components/SwitchLang'
import IconYoutube from '@/components/IconYoutube'
import IconLinkedin from '@/components/IconLinkedin'
import Parallax from '@/components/animation/Parallax'

export default {
    components: {
        Logo,
        SwitchLang,
        IconYoutube,
        IconLinkedin,
        Parallax
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.footer
    border-top: 1px solid rgba(#e5e5e5, .5)
    position: relative
    font-weight: 500
    display: flex
    line-height: 2
    margin-top: 348px
    @include media-breakpoint-up($xxl)
        margin-left: calc((-100vw + 1920px) * 0.5)
        margin-right: calc((-100vw + 1920px) * 0.5)
    @include media-breakpoint-down($sm)
        margin-top: 200px
    .before
        content: ""
        display: block
        width: 100%
        background-image: url('./../assets/cross-red-fade.svg')
        background-size: 45px 45px
        background-position: 0 0
        position: absolute
        bottom: 100%
        left: 0
        right: 0
        height: 348px
        box-sizing: content-box
        padding-bottom: 10%
        margin-bottom: -10%
        z-index: -1
        @media print
            display: none
        @include media-breakpoint-down($sm)
            height: 200px
    @include media-breakpoint-down($lg)
        flex-direction: column
    @media print
        border: none
        margin-top: 2.4cm
        margin-left: 9.6%
        margin-right: 9.6%
        page-break-inside: avoid
        break-inside: avoid
    .logo-container
        margin: auto
    .logo
        margin-top: 15px
        /deep/ path
            fill: rgba(#767e88, .7)
        &.linkedin
            width: 21px
            height: auto
        &.youtube
            width: 25px
            height: auto
    .link:hover
        .logo
            /deep/ path
                fill: #ff2b2a
.footer-sizer
    // display: flex
    flex: 1
    // margin: auto
    background-color: #ffffff
    // @include media-breakpoint-down($lg)
    //     flex-direction: column
.gabarit
    max-width: 1920px
    flex: 1
    display: flex
    margin: auto
    @include media-breakpoint-down($lg)
        flex-direction: column
.intro-content
    border-right: 1px solid rgba(#e5e5e5, .5)
    padding-left: 3.625%
    padding-top: 3.625%
    padding-right: 3.625%
    padding-bottom: 3.625%
    .text
        width: 300px
        margin-left: 70px
        color: #767e88
        font-weight: normal
        margin-top: 1.5em
        opacity: 0.7
    @include media-breakpoint-down($lg)
        border-right: none
        border-bottom: 1px solid rgba(#e5e5e5, .5)
        padding-left: 9.6%
        padding-right: 9.6%
        .text
            width: auto
            margin-left: 0
            margin-right: 0
    @include media-breakpoint-down($lg)
        padding-bottom: 10.625%
        padding-top: 6.25%
    @media print
        padding: 0
        border: none
.main-content
    padding-top: 4.25%
    padding-left: 3.78%
    padding-bottom: 5%
    padding-right: 2.1%
    display: flex
    flex: 1
    flex-wrap: wrap
    justify-content: flex-start
    // @include media-breakpoint-down($lg)
    //     justify-content: center
    @include media-breakpoint-down($md)
        padding-left: 24px
        padding-right: 24px
        justify-content: flex-start
    @media print
        display: none
    .division
        width: 220px
        display: flex
        flex-direction: column
        flex-wrap: wrap
        margin-bottom: 8%
        padding-right: 20px
        @include media-breakpoint-up($xl)
            width: 220px
        @include media-breakpoint-up($xxl)
            width: 25%
        @include media-breakpoint-down($hd)
            width: 50%
            text-align: left
        // @include media-breakpoint

    .share-link-icon
        display: inline-block
        height: 50px
        width: 50px
.end-content
    width: 21.875%
    border-left: 1px solid rgba(#e5e5e5, .5)
    @include media-breakpoint-down($lg)
        border-left: none
        width: auto
    @media print
        display: none
    .division
        display: flex
        align-items: center
        justify-content: center
        height: 42%
        &.last-division
            flex-direction: column
            span
                font-size: 15px
                font-weight: 300
                opacity: .5
        @include media-breakpoint-down($lg)
            min-height: 90px
            border-top: 1px solid rgba(#e5e5e5, .5)
        img
            max-width: 100%
            height: auto
        &+.division
            border-top: 1px solid rgba(#e5e5e5, .5)
h3
    font-size: 17px
    font-weight: 500
    color: #ff2b2a
a
    font-weight: 300
    text-decoration: none
    font-size: 17px
    transition: color 0.5s
    color: rgba(#767e88, .7)
    &:hover
        color: #ff2b2a
.link
    position: relative
    font-size: 0
    display: inline-block
    max-width: 178px
    height: auto
    width: 100%
    .default-icon
        // transition: opacity 0.5s
        // will-change: opacity
        // opacity: .3925
        //
        // &:hover
        //     opacity: 1
.switch-lang
    /deep/ .current
        height: auto
        padding: 12px
        color: rgba(#767e88, .7)
        svg
            path
                fill: rgba(#767e88, .7)
</style>
